import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _venues = [];

let VenueStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _venues.filter(function(e) { return e !== undefined; });
    },
    getById: function(id) {
        return _venues.find(function(e) { return e !== undefined && e.id == id; });
    },
    add: function(entity) {
        if (entity !== undefined && entity.id !== undefined) {
            let index = _venues.findIndex(function(e) { return e !== undefined && e.id == entity.id; });
            if (0 <= index) {
                _venues[index] = entity;
            } else {
                _venues.push(entity);
            }
        }
    },
    remove: function(data) {
        if (data.id !== undefined) {
            let index = _venues.findIndex(function(e) { return e !== undefined && e.id == data.id; });
            if (0 <= index) {
                if (data.deleted) {
                    delete _venues[index];
                } else if (_venues[index].loading !== undefined) {
                    _venues[index].loading = undefined;
                }
            }
        }
    },

});

VenueStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.VENUE_LIST:
            action.data.forEach(VenueStore.add);
            VenueStore.emitChange();
            break;

        case ActionTypes.VENUE_LIST_ERROR:
            VenueStore.emitChange();
            break;

        case ActionTypes.VENUE_INFO:
            VenueStore.add(action.data);
            VenueStore.emitChange();
            break;

        case ActionTypes.VENUE_INFO_ERROR:
            VenueStore.emitChange();
            break;

        case ActionTypes.VENUE_SAVE:
            VenueStore.add(action.data);
            VenueStore.emitChange();
            break;

        case ActionTypes.VENUE_UPDATE:
            VenueStore.add(action.data);
            VenueStore.emitChange();
            break;

        case ActionTypes.VENUE_DELETE:
            VenueStore.remove(action.data);
            VenueStore.emitChange();
            break;

        default:
            break;

    }

});

export default VenueStore;
